module.exports = __webpack_public_path__ + "static/media/image12.4f750e40.png";